export default "__VITE_ASSET__327b7ce3__"